import { LocationChangeListener, PlatformLocation } from '@angular/common';
import { inject, Inject, Injectable } from '@angular/core';
import { GEOTAB_FAKE_BASE_URL, GEOTAB_STATE, GeotabState, getGeotabPageHash, navigateTo$ } from './geotab-utils';

@Injectable({
  providedIn: 'platform',
  useFactory: createGeotabPlatformLocation,
})
export class GeotabPlatformLocation extends PlatformLocation {
  private location!: Location;
  private _history!: History;

  constructor(@Inject(GEOTAB_STATE) private geotabState: GeotabState) {
    super();
    this._init();
  }

  _init() {
    this.location = window.location;
    this._history = window.history;
  }

  override getBaseHrefFromDOM(): string {
    return GEOTAB_FAKE_BASE_URL;
    // return null as any;
    // return getDOM().getBaseHref(this._doc)!;
  }

  override onPopState(_fn: LocationChangeListener): VoidFunction {
    const fn2 = () => {};
    window.addEventListener('popstate', fn2, false);
    return () => window.removeEventListener('popstate', fn2);
    // window.addEventListener('popstate', fn, false);
    // return () => window.removeEventListener('popstate', fn);
  }

  override onHashChange(_fn: LocationChangeListener): VoidFunction {
    const fn2 = () => {
      const rideViewUrl: string = this.geotabState.getState().rideViewUrl || '';
      navigateTo$.next(rideViewUrl);
    };
    window.addEventListener('hashchange', fn2, false);
    return () => window.removeEventListener('hashchange', fn2);
    // window.addEventListener('hashchange', fn as any, false);
    // return () => window.removeEventListener('hashchange', fn as any);
  }

  override get href(): string {
    return this.location.href;
  }
  override get protocol(): string {
    return this.location.protocol;
  }
  override get hostname(): string {
    return this.location.hostname;
  }
  override get port(): string {
    return this.location.port;
  }
  override get pathname(): string {
    return this.location.pathname;
  }
  override get search(): string {
    return this.location.search;
  }
  override get hash(): string {
    return this.location.hash;
  }
  override set pathname(newPath: string) {
    this.location.pathname = newPath;
  }

  override pushState(_state: any, _title: string, url: string): void {
    this.geotabState.gotoPage(getGeotabPageHash(), { rideViewUrl: url.substring(GEOTAB_FAKE_BASE_URL.length) });
  }

  override replaceState(_state: any, _title: string, url: string): void {
    this.geotabState.setState({ rideViewUrl: url.substring(GEOTAB_FAKE_BASE_URL.length) });
  }

  override forward(): void {}

  override back(): void {
    this._history.back();
  }

  override historyGo(_relativePosition: number = 0): void {}

  override getState(): unknown {
    return undefined;
  }
}

export function createGeotabPlatformLocation() {
  return new GeotabPlatformLocation(inject(GEOTAB_STATE));
}
